module.exports = __webpack_public_path__ + "static/media/ok.cdb677c4.png";